import { render, staticRenderFns } from "./HotelWiseBookingReport.vue?vue&type=template&id=589e2735&scoped=true"
import script from "./HotelWiseBookingReport.vue?vue&type=script&lang=js"
export * from "./HotelWiseBookingReport.vue?vue&type=script&lang=js"
import style0 from "./HotelWiseBookingReport.vue?vue&type=style&index=0&id=589e2735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e2735",
  null
  
)

export default component.exports